import React from 'react';
import { Page, CardDiscount } from '../../components';
import { Button, ToastDanger } from '../../ui';
import { useSelector, useDispatch } from 'react-redux';
import { discountService } from '../../store/services';
import { cartActions, userActions } from '../../store/actions';
import { getAllUrlParams, applyDiscounts } from '../../libs';
import { HighlightOffOutlined } from '@mui/icons-material';

export function DiscountCode() {
    const dispatch = useDispatch();
    const [code, setCode] = React.useState("");
    const [showToast, setShowToast] = React.useState(false);
    const { discount } = useSelector(state => state.cartData);
    const [discounts, setDiscounts] = React.useState([]);
    const { totalPrice, totalItems } = getAllUrlParams();
    const _totalPrice = React.useMemo(() => parseFloat(totalPrice), [totalPrice]);

    const [discountCodesList, setDiscountCodesList] = React.useState(null);

    React.useEffect(() => {
        discountService.getAll()
            .then(data => {
                setDiscountCodesList(data);
            })
            .catch(err => {
                console.error(err);
            });
    }, [])

    React.useEffect(() => {
        if (discount)
            setDiscounts(discount);
    }, [discount]);

    React.useEffect(() => {
        dispatch(userActions.getInfo());
    }, [dispatch]);

    const handleApplyCode = (codePassed = null) => {
        const _code = codePassed || code;
        
        if(discounts.length > 0) {
            setShowToast(1);
            return;
        }
        
        if (_code) {
            discountService.get(_code)
                .then(data => {
                    if (data.message) {
                        setShowToast(false);
                        if (discounts.length === 0) {
                            const discount = data.discount;
                            if(discount.minimumItems > parseInt(totalItems)) {
                                setShowToast(2);
                                return;
                            }
                            discount.credits = parseFloat(discount.credits);
                            setDiscounts([discount]);
                            dispatch(cartActions.applyDiscount([discount]));
                            setCode('');
                        }
                        else
                            setShowToast(true);
                    }
                    else
                        setShowToast(true);
                })
                .catch(err => {
                    setShowToast(true);
                });
        }
    }

    const handleRemoveDiscount = (pin) => {
        const newDiscountsApplied = discounts.filter(discount => discount.code !== pin);
        dispatch(cartActions.applyDiscount(newDiscountsApplied));
        setDiscounts(newDiscountsApplied);
        setShowToast(false);
    }

    const [totalDiscounts, showedPriceDiscounted] = React.useMemo(() => {
        const totalPriceWithoutDiscounts = _totalPrice;
        const resultsDiscounts = applyDiscounts(discounts, _totalPrice);
        const totalPriceWithDiscounts = resultsDiscounts.total;

        return [totalPriceWithoutDiscounts - totalPriceWithDiscounts, totalPriceWithDiscounts];
    }, [_totalPrice, discounts]);

    return (
        <Page visibleBottomNavigation={false}
            title={"Codici Sconto"}>
            <div className="container p-3">
                <p>Hai un codice sconto? Inseriscilo nel campo sottostante e premi "Applica Codice"</p>
                <input type="text" placeholder="Inserisci Codice Sconto" className='w-100 form-control rounded-5 mt-3' value={code} onChange={(e) => {
                    setCode(e.target.value)
                    setShowToast(false)
                }} />
                <Button onClick={() => handleApplyCode()} otherClass={`mt-3 p-1 ${showToast ? 'mb-2' : 'mb-5'}`} disabled={!code}>
                    Applica Codice
                </Button>
                {showToast && <div className='mb-4'>
                    <ToastDanger>
                        {decodeError(showToast)}
                    </ToastDanger>
                </div>}
                <div className='fw-bold fs-4 mb-3'>Sconti Applicati:</div>
                {
                    discounts.map((discount, index) => {
                        return <div className={`d-flex justify-content-between mb-2 border-bottom position-relative pb-2`} key={index}>
                            <div>
                                <div className='fw-bold mb-2'>{discount.title}</div>
                                <div className=''>{discount.code}</div>
                            </div>
                            <div>
                                <button className='btn btn-link text-danger' onClick={() => handleRemoveDiscount(discount.code)}>
                                    <HighlightOffOutlined fontSize="large" />
                                </button>
                            </div>
                        </div>
                    })
                }
                <div className="d-flex justify-content-between mb-2">
                    <div>Totale Sconti:</div>
                    <div className='fw-bold text-primary'>{totalDiscounts.toFixed(2).replace(".", ",")} €</div>
                </div>
                <div className="d-flex justify-content-between">
                    <div>Totale Ordine:</div>
                    <div className='fw-bold'>{showedPriceDiscounted.toFixed(2).replace(".", ",")} €</div>
                </div>
                {discountCodesList &&
                    <div className='fw-bold fs-4 mt-5'>Codici Sconto Disponibili:</div>}

                {discountCodesList && discountCodesList.map
                    && discountCodesList.map((discount, index) => {
                        return (
                            <CardDiscount
                                key={index}
                                title={discount.description}
                                code={discount.code}
                                dateLimit={discount.expiresAt}
                                minItemTotal={discount.minItemTotal}
                                shareAndCopy={false}
                                applyCode={handleApplyCode} />
                        )
                    })}
            </div>
        </Page>
    );
}

const decodeError = (error) => {
    switch (error) {
        case 1:
            return 'Puoi applicare un solo codice sconto';
        case 2:
            return 'Devi inserire più prodotti per poter applicare il codice sconto';
        default:
            return 'Il codice sconto inserito non è valido';
    }
}